
export default {

  state:{
    framingham : null,
    nyha       : null,
  },

  mutations: {

    setSemCardiologica(state, newData){
      state.framingham  = newData.framingham;
      state.nyha        = newData.nyha;
    },

    setFramingham(state, data){
      state.framingham = data
    },
    
    setNyha(state, data){
      state.nyha = data
    },


    resetSemCardiologica(state){
      state.framingham  = null;
      state.nyha        = null;
    },
    
  }
}